<script>
  import { VueMaskDirective as mask } from 'v-mask'
  // import service from '../../../../domain/leiloes/services'

  export default {
    components: {},
    nome: 'relatorios',
    directives: {mask},
    data () {
      return {
        leilao: null
      }
    },
    computed: {},
    mounted () {
      // const body = document.body
      // body.appendChild(this.$el)
    },
    activated () {
    },
    created () {
      this.$on('printer', this.print)
      /* this.$loaderOverlay.open().message('Aguarde enquanto carregamos a aplicação')
      service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.leilao = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        }) */
    },
    beforeDestroy () {
      // document.body.removeChild(this.$el)
    },
    deactivated () {
    },
    watch: {},
    methods: {
      print () {
        let areaPrint = document.createElement('div')
        areaPrint.classList.add('removeAfterPrint')
        let printer = document.querySelector('#container-printer')
        printer = printer.cloneNode(true)
        printer.classList.add('removeAfterPrint')
        areaPrint.appendChild(printer)
        document.body.appendChild(areaPrint)
        let app = document.querySelector('#app')
        app.classList.add('hide')
        this.$nextTick(() => {
          window.print()
          setTimeout(() => {
            app.classList.remove('hide')
            let nodeToRemove = document.querySelector('.removeAfterPrint')
            document.body.removeChild(nodeToRemove)
          }, 300)
        })
      }
    }
  }
</script>

<template>
  <div class="relatorio">
    <div class="r-header hidden-print">
      <div class="header1">
        <h1>Relatórios Arrematantes
        </h1>
        <router-link :to="{name: 'arrematantes'}" class="exit">Sair do modo relatório</router-link>
      </div>
      <div class="header2 hidden-print">
        <ul class="r-options" role="tablist">
          <li role="presentation">
          </li>
        </ul>
        <div class="r-buttons">
          <u-button class="btn-info2" @click="print"><i class="fa fa-print m-r-xs"></i> Imprimir</u-button>
        </div>
      </div>
    </div>
    <div class="r-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss">
  .relatorio {
    background: #e9ebee !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Arial, sans-serif;
    color: rgb(29, 33, 41);
    .header1 {
      background: #394959;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      color: #FFFFFF;
      h1 {
        margin: 0;
        padding: 0;
        font-weight: 300;
        color: #FFFFFF;
        font-size: 18px;
      }
      .exit {
        display: block;
        &::before {
          content: '';
          padding-left: 20px;
          background-image: unquote("url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzLjguMyAoMjk4MDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmljX2Jyb3dzZXJfZGVsZXRlX2xpZ2h0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN0eWxlc2hlZXQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJMaWdodC1UaGVtZS1TdHlsZXNoZWV0LS0tSWNvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTU3LjAwMDAwMCwgLTUwMC4wMDAwMDApIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0I0QjRCNCI+CiAgICAgICAgICAgIDxnIGlkPSJTaWRlYmFyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1My4wMDAwMDAsIDQwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJCcm93c2VyLUFjdGlvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkwNS4wMDAwMDAsIDg2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJOb3JtYWwiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iaWNfYnJvd3Nlcl9kZWxldGVfbGlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMC4wMDAwMDAsIDEwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEwLDAgTDAsMTAiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEwLDEwIEwwLDAiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)");
          background-repeat: no-repeat;
          background-position: center;
        }
        padding: 4px 7px;
        border-radius: 5px;
        &:hover {
          background: #293241;
        }
      }
    }
    .header2 {
      background: #FFFFFF;
      height: 43px;
      display: flex;
      justify-content: space-between;
    }
    .r-buttons{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 0;
      padding-right: 15px;
      white-space: nowrap;
    }
    .r-options {
      margin: 0;
      padding: 0;
      li {
        margin: 0;
        padding: 0;
        display: inline-block;
        list-style-type: none;
        max-width: 100%;
        position: relative;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      li a {
        color: #4b4f56;
        display: inline-block;
        vertical-align: baseline;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        div {
          border: 0;
          font-size: 14px;
          line-height: 18px;
          margin: 8px 0;
          padding: 5px 16px 4px;
          position: relative;
          display: block;
        }
        span {
          bottom: 0;
          left: 8px;
          position: absolute;
          right: 8px;
          background-color: #edf2fa;
          padding-top: 3px;
          display: none;
        }
        &:hover {
          span {
            display: block;
          }
        }
        &.active {
          font-weight: bold;
          span {
            background: #4267b2 !important;
            display: block;
          }
        }
      }
    }
    .r-content{
      flex: 1;
      display: flex;
      justify-content: space-between;
      overflow-y: auto;
      .r-container{
        flex: 1;
      }
    }
    .is-loading{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .relatorio-print{
    font-family: Arial, sans-serif !important;
  }
  .r-table{
    width: 736px;
    margin: 20px auto;
    background-color: rgb(255, 255, 255);
    border-width: 1px;
    border-radius: 4px;
    border-color: rgb(218, 221, 225);
  }
  .r-table-header{
    border-bottom: 1px solid #dadcde;
    padding: 12px;
  }
  .r-table-content{
    padding: 12px;
  }
  .tab-border{
    border: solid 1px #dadcde;
  }

  .btn-info2{
    letter-spacing: normal;
    color: rgb(255, 255, 255);
    font-size: 12px;
    font-weight: bold;
    font-family: Arial, sans-serif;
    line-height: 26px;
    text-align: center;
    background: rgb(53, 120, 229);
    border-color: rgb(53, 120, 229);
    height: 28px;
    padding-left: 12px;
    padding-right: 12px;
    border: 1px;
    border-radius: 4px;
    box-shadow: none;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
    position: relative;
    text-shadow: none;
    transition: all 300ms cubic-bezier(.1, .7, .1, 1), border-width 1ms;
    vertical-align: middle;

    &:hover{
      background: rgb(40, 81, 163);
      border-color: rgb(40, 81, 163);
    }
  }

  .table-arremate{
    > thead > tr > th{
      color: #000000;
      font-weight: bold;
      font-size: 12px;
      border-bottom: 1px solid rgb(220, 222, 228);
      line-height: 39px;
    }
    > tbody > tr > td{
      color: rgb(29, 33, 41);
      padding: 4px 0;
      border-bottom: 1px solid rgb(220, 222, 228);
    }
    > tbody > tr:not(.list){
      &:first-child td, &:last-child td{
        border-bottom: none !important;
      }
    }
    > thead > tr > th, > tbody > tr > td{
      padding-left: 24px;
      padding-right: 8px;
    }
  }
  .no-border-top{
    border-top: none !important;
  }

  @media print {
    html, body {
      /*height: 100% !important;*/
    }
    .relatorio, .header1, .header2, .r-content, .r-container{
      position: relative;
      display: block !important;
      overflow: auto !important;
      height: auto !important;
      bottom: auto !important;
      flex: none !important;
    }
    .r-table {
      width: 100%;
    }
    .relatorio-print{
      /*height: 100% !important;*/
    }
    .printer-page{
      height: 100%;
    }
  }
  .p-page-numer{
    /*position: absolute;
    right: 0;
    bottom: -30px;*/
    text-align: center;
  }
  .printer-page{
    page-break-after:always;
  }
  .r-table-min{
    &.table > tbody > tr > th,
    &.table > tbody > tr > td,
    &.table > tfoot > tr > th,
    &.table > tfoot > tr > td{
      padding: 4px 7px;
      font-size: 12px;
    }
    &.table > thead > tr > th{
      padding: 4px 7px;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// Relatorios.vue?bc9a9346